import Vue from 'vue'
import axios from 'axios'
import cacher from './mod_cacher'

const methode = {
	state: {
		api_path: 'https://www.dayton.com/external-feeds/json/apps/v1/',
		img_mods: {
			compact: 'compact', // NO CROP (150xauto @ 76%)
			md: 'md', // NO CROP (400xauto)
			large: 'large', // NO CROP (800xauto)
			lowres: 'lowres', // NO CROP (1000xauto @ 75%)
			thumbnail: 'thumbnail', // CROPPED (120x120 @ 70%)
			widescreen: 'widescreen', // CROPPED (1140x600)
			portrait: 'portrait', // CROPPED (235x350)
			inline: 'inline', // CROPPED (365x205)
			medium: 'medium', // CROPPED (750x422)
			square: 'square', // CROPPED (450x450)
		},
	},

	normalize_api_data: function(api_data) {
		let vm = this;
		let channel = api_data.channel;
		let items = api_data.channel.item;

		let normalized_data = {
			title: channel.title,
			link: channel.link,
			type: channel.type,
			source: channel.source,
			list_items: []
		}

		// NORMALIZE LIST ITEMS
		items.map(function(item) {
			let normalized_item = vm.normalize_single_api_list_item(item);
			normalized_data.list_items.push(normalized_item);
		});

		return normalized_data;
	},

	normalize_single_api_list_item: function(list_item) {
		let vm = this;
		let normalized_item = {
			uuid: list_item.guid,
			item_class: list_item.item_class,
			file: list_item.file,
			link: list_item.link,
			canonical_url: list_item.canonical_url,
			page_title: list_item.page_title,
			title: list_item.title,
			summary: list_item.summary,
			subhead: list_item.subhead,
			author: list_item.author,
			bylines: list_item.bylines,
			byline_source: list_item.byline_source,
			pub_date: list_item.pub_date,
			first_pub_date: list_item.first_pub_date,
			last_pub_date: list_item.last_pub_date,
			last_edit_date: list_item.last_edit_date,
			full_text: list_item.full_text,
			primary_category: list_item.primary_category,
			tag: list_item.tags,
			topics: list_item.topics,
			images: list_item.images,
			videos: list_item.videos,
			originating_site: list_item.originating_site,
			originating_domain: 'www.'+list_item.originating_site,
			sites: list_item.sites,
			categories: list_item.categories,
			thumbnail_url: list_item.thumbnail_url,
			master_image_url: ''
		}

		// DETERMINE MASTER IMAGE URL
		if(normalized_item.thumbnail_url != '') { normalized_item.master_image_url = normalized_item.thumbnail_url}
		else if(normalized_item.videos.length > 0) {
			if(normalized_item.videos[0].image) {
				normalized_item.master_image_url = normalized_item.videos[0].image.url;
			}
		}
		else if(normalized_item.images.length > 0) {
			if(normalized_item.images[0].url) {
				normalized_item.master_image_url = normalized_item.images[0].url;
			}
		}


		return normalized_item;
	},

	create_methode_api_url: function(uuid, verbose, limit) {
		let vm = this;
		let api_url = vm.state.api_path;

		if(verbose) {
			api_url += '?verbose=true';
		}
		else {
			api_url += '?verbose=false'
		}

		if(!limit || limit == 0) {
			limit = 25;
		}

		api_url += '&count='+limit;

		api_url += '&id='+uuid;

		return api_url;
	},

	resize_image: function(url, size) {
		return url.replace(/\/rw\//g, '/rf/'+this.state.img_mods[size]+'/');
	},

	resize_image_compact: function(url) {
		return url.replace(/\/rw\//g, '/rf/image_compact/');
	},

	resize_image_md: function(url) {
		return url.replace(/\/rw\//g, '/rf/image_md/');
	},

	fetch_methode_api_data: function(uuid, limit) {
		let vm = this;
		let count = 0;

		if(limit) {
			count = limit;
		}
		
		let data_url = vm.create_methode_api_url(uuid, true, count);
			data_url = cacher.create_file_get_url(data_url);

		return axios.get(data_url);
	},
}

export default methode


// WEBPACK FOOTER //
// ./src/store/modules/mod_methode.js